import { indexItems } from "@/mocks/home";

export default function SectionIndex() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">主题专区</h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">九大主题分类 — 精准找到你想看的</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#media"
              className="group flex items-center gap-4 p-4 rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-300/50 transition-all duration-200"
            >
              <div className="w-12 h-12 rounded-lg bg-primary-500/10 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-500/20 transition-colors">
                <i className={`${item.icon} text-xl text-primary-500`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900">{item.title}</h3>
                <p className="text-xs text-foreground-600 mt-0.5">{item.desc}</p>
              </div>
              <span className="text-xs text-foreground-500 whitespace-nowrap">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}